/**
 * @generated SignedSource<<44e0b725f42a6502c0a668748231d52d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type PriceRangeInput = {
  max?: number | null
  min?: number | null
}
export type CemeterySortInput = {
  field: string
  order: string
}
export type prefectureStationListPage_indexQuery$variables = {
  prefectureRoma: string
  stationId: number
  sectionTypes?: ReadonlyArray<string> | null
  cemeteryTypes?: ReadonlyArray<string> | null
  sects?: ReadonlyArray<string> | null
  sectionCapacities?: ReadonlyArray<string> | null
  facilities?: ReadonlyArray<string> | null
  features?: ReadonlyArray<string> | null
  priceMax?: string | null
  priceMin?: string | null
  priceRange?: PriceRangeInput | null
  from?: number | null
  sort?: CemeterySortInput | null
}
export type prefectureStationListPage_indexQuery$data = {
  readonly station: {
    readonly mainStation: {
      readonly stationId: number
    } | null
    readonly ' $fragmentSpreads': FragmentRefs<'ListPageContextProvider_station'>
  } | null
  readonly cemeteries: {
    readonly ' $fragmentSpreads': FragmentRefs<
      | 'CemeteryList_cemeteries'
      | 'StructuredData_cemeteries'
      | 'ListPageContextProvider_pagination'
      | 'NoCemeteries_cemeteries'
      | 'ThirdPartyAdData_cemeteries'
      | 'SeoHead_cemeteries'
    >
  }
  readonly averages: {
    readonly ' $fragmentSpreads': FragmentRefs<'useAveragePrices_averages'>
  }
  readonly rankingCemeteries: {
    readonly ' $fragmentSpreads': FragmentRefs<
      | 'Faq_rankingCemeteries'
      | 'Ranking_rankingCemeteries'
      | 'PopularCemeteries_rankingCemeteries'
    >
  }
  readonly highScoreCemeteries: {
    readonly ' $fragmentSpreads': FragmentRefs<'HighScoreCemeteries_highScoreCemeteries'>
  }
  readonly stations: {
    readonly ' $fragmentSpreads': FragmentRefs<'StationLinksList_stations'>
  }
  readonly conditions: {
    readonly ' $fragmentSpreads': FragmentRefs<'ConditionLinksList_conditions'>
  }
  readonly sectionTypes: {
    readonly ' $fragmentSpreads': FragmentRefs<'SearchSectionTypeLinks_sectionTypes'>
  }
  readonly shopCities: {
    readonly ' $fragmentSpreads': FragmentRefs<'ShopLinksList_Fragment'>
  }
}
export type prefectureStationListPage_indexQuery = {
  variables: prefectureStationListPage_indexQuery$variables
  response: prefectureStationListPage_indexQuery$data
}

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'cemeteryTypes'
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'facilities'
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'features'
    },
    v3 = {
      defaultValue: 0,
      kind: 'LocalArgument',
      name: 'from'
    },
    v4 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'prefectureRoma'
    },
    v5 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'priceMax'
    },
    v6 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'priceMin'
    },
    v7 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'priceRange'
    },
    v8 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'sectionCapacities'
    },
    v9 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'sectionTypes'
    },
    v10 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'sects'
    },
    v11 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'sort'
    },
    v12 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'stationId'
    },
    v13 = [
      {
        kind: 'Variable',
        name: 'id',
        variableName: 'stationId'
      }
    ],
    v14 = {
      alias: 'stationId',
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null
    },
    v15 = {
      alias: null,
      args: null,
      concreteType: 'StationSimple',
      kind: 'LinkedField',
      name: 'mainStation',
      plural: false,
      selections: [v14 /*: any*/],
      storageKey: null
    },
    v16 = {
      kind: 'Variable',
      name: 'cemeteryTypes',
      variableName: 'cemeteryTypes'
    },
    v17 = {
      kind: 'Variable',
      name: 'facilities',
      variableName: 'facilities'
    },
    v18 = {
      kind: 'Variable',
      name: 'features',
      variableName: 'features'
    },
    v19 = {
      items: [
        {
          kind: 'Variable',
          name: 'prefectures.0',
          variableName: 'prefectureRoma'
        }
      ],
      kind: 'ListValue',
      name: 'prefectures'
    },
    v20 = {
      kind: 'Variable',
      name: 'priceMax',
      variableName: 'priceMax'
    },
    v21 = {
      kind: 'Variable',
      name: 'priceMin',
      variableName: 'priceMin'
    },
    v22 = {
      kind: 'Variable',
      name: 'sectionCapacities',
      variableName: 'sectionCapacities'
    },
    v23 = {
      kind: 'Variable',
      name: 'sects',
      variableName: 'sects'
    },
    v24 = {
      items: [
        {
          kind: 'Variable',
          name: 'stations.0',
          variableName: 'stationId'
        }
      ],
      kind: 'ListValue',
      name: 'stations'
    },
    v25 = [
      {
        fields: [
          v16 /*: any*/,
          v17 /*: any*/,
          v18 /*: any*/,
          v19 /*: any*/,
          v20 /*: any*/,
          v21 /*: any*/,
          {
            kind: 'Variable',
            name: 'priceRange',
            variableName: 'priceRange'
          },
          v22 /*: any*/,
          {
            kind: 'Variable',
            name: 'sectionTypes',
            variableName: 'sectionTypes'
          },
          v23 /*: any*/,
          v24 /*: any*/
        ],
        kind: 'ObjectValue',
        name: 'filter'
      },
      {
        fields: [
          {
            kind: 'Variable',
            name: 'from',
            variableName: 'from'
          },
          {
            kind: 'Literal',
            name: 'size',
            value: 20
          }
        ],
        kind: 'ObjectValue',
        name: 'page'
      },
      {
        kind: 'Variable',
        name: 'sort',
        variableName: 'sort'
      }
    ],
    v26 = [v24 /*: any*/],
    v27 = {
      fields: v26 /*: any*/,
      kind: 'ObjectValue',
      name: 'filter'
    },
    v28 = [v27 /*: any*/],
    v29 = [
      v27 /*: any*/,
      {
        kind: 'Literal',
        name: 'page',
        value: {
          from: 0,
          size: 5
        }
      },
      {
        kind: 'Literal',
        name: 'sort',
        value: {
          field: 'ranking',
          order: 'desc'
        }
      }
    ],
    v30 = [
      {
        fields: [
          v19 /*: any*/,
          {
            kind: 'Literal',
            name: 'requestable',
            value: true
          },
          v24 /*: any*/
        ],
        kind: 'ObjectValue',
        name: 'filter'
      },
      {
        kind: 'Literal',
        name: 'page',
        value: {
          from: 0,
          size: 3
        }
      },
      {
        kind: 'Literal',
        name: 'sort',
        value: {
          field: 'enquete_score',
          order: 'desc'
        }
      }
    ],
    v31 = {
      kind: 'Literal',
      name: 'limit',
      value: 999
    },
    v32 = [
      v31 /*: any*/,
      {
        kind: 'Variable',
        name: 'stationId',
        variableName: 'stationId'
      }
    ],
    v33 = [
      {
        fields: v26 /*: any*/,
        kind: 'ObjectValue',
        name: 'cemeteryFilter'
      },
      {
        kind: 'Literal',
        name: 'limit',
        value: 99
      }
    ],
    v34 = [
      {
        kind: 'Literal',
        name: 'attributeCode',
        value: 'section_type'
      },
      {
        fields: [
          v16 /*: any*/,
          v17 /*: any*/,
          v18 /*: any*/,
          v19 /*: any*/,
          v20 /*: any*/,
          v21 /*: any*/,
          v22 /*: any*/,
          v23 /*: any*/,
          v24 /*: any*/
        ],
        kind: 'ObjectValue',
        name: 'cemeteryFilter'
      }
    ],
    v35 = [
      v31 /*: any*/,
      {
        kind: 'Variable',
        name: 'prefectureRoma',
        variableName: 'prefectureRoma'
      }
    ],
    v36 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'name',
      storageKey: null
    },
    v37 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'prefectureRoma',
      storageKey: null
    },
    v38 = {
      alias: 'cemeteryId',
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null
    },
    v39 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'total_score',
      storageKey: null
    },
    v40 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'count',
      storageKey: null
    },
    v41 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'code',
      storageKey: null
    },
    v42 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'director_comment',
      storageKey: null
    },
    v43 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'distance',
      storageKey: null
    },
    v44 = [v36 /*: any*/],
    v45 = [v36 /*: any*/, v41 /*: any*/],
    v46 = {
      alias: null,
      args: null,
      concreteType: 'CemeteryChoice',
      kind: 'LinkedField',
      name: 'cemetery_types',
      plural: true,
      selections: v45 /*: any*/,
      storageKey: null
    },
    v47 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'path',
      storageKey: null
    },
    v48 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'alt',
      storageKey: null
    },
    v49 = [v47 /*: any*/, v48 /*: any*/],
    v50 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'category_code',
      storageKey: null
    },
    v51 = [
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price1',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price1_unit',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price2',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price2_unit',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'purchase_price',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'purchase_price_unit',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'calculated_purchase_price',
        storageKey: null
      },
      v50 /*: any*/,
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'purchase_price_option',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price3',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'simulated_price3',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price4',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'price4_name',
        storageKey: null
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'lot_area',
        storageKey: null
      }
    ],
    v52 = {
      alias: null,
      args: null,
      concreteType: 'CemeteryBestPriceByCategory',
      kind: 'LinkedField',
      name: 'best_price_by_category',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          concreteType: 'CemeteryPriceAndSpec',
          kind: 'LinkedField',
          name: 'normal',
          plural: false,
          selections: v51 /*: any*/,
          storageKey: null
        },
        {
          alias: null,
          args: null,
          concreteType: 'CemeteryPriceAndSpec',
          kind: 'LinkedField',
          name: 'nokotsu',
          plural: false,
          selections: v51 /*: any*/,
          storageKey: null
        },
        {
          alias: null,
          args: null,
          concreteType: 'CemeteryPriceAndSpec',
          kind: 'LinkedField',
          name: 'jumoku',
          plural: false,
          selections: v51 /*: any*/,
          storageKey: null
        },
        {
          alias: null,
          args: null,
          concreteType: 'CemeteryPriceAndSpec',
          kind: 'LinkedField',
          name: 'eitai_kuyo',
          plural: false,
          selections: v51 /*: any*/,
          storageKey: null
        }
      ],
      storageKey: null
    },
    v53 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'total',
      storageKey: null
    },
    v54 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'cemeteryCount',
      storageKey: null
    }
  return {
    fragment: {
      argumentDefinitions: [
        v0 /*: any*/,
        v1 /*: any*/,
        v2 /*: any*/,
        v3 /*: any*/,
        v4 /*: any*/,
        v5 /*: any*/,
        v6 /*: any*/,
        v7 /*: any*/,
        v8 /*: any*/,
        v9 /*: any*/,
        v10 /*: any*/,
        v11 /*: any*/,
        v12 /*: any*/
      ],
      kind: 'Fragment',
      metadata: null,
      name: 'prefectureStationListPage_indexQuery',
      selections: [
        {
          alias: 'station',
          args: v13 /*: any*/,
          concreteType: 'StationWithCityCemeteryCount',
          kind: 'LinkedField',
          name: 'getStationWithCityCemeteryCount',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'ListPageContextProvider_station'
            },
            v15 /*: any*/
          ],
          storageKey: null
        },
        {
          alias: 'cemeteries',
          args: v25 /*: any*/,
          concreteType: 'CemeteryResult',
          kind: 'LinkedField',
          name: 'listCemeteries',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'CemeteryList_cemeteries'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'StructuredData_cemeteries'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'ListPageContextProvider_pagination'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'NoCemeteries_cemeteries'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'ThirdPartyAdData_cemeteries'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'SeoHead_cemeteries'
            }
          ],
          storageKey: null
        },
        {
          alias: 'averages',
          args: v28 /*: any*/,
          concreteType: 'CemeteryPriceAverages',
          kind: 'LinkedField',
          name: 'averageCemeteryPrices',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'useAveragePrices_averages'
            }
          ],
          storageKey: null
        },
        {
          alias: 'rankingCemeteries',
          args: v29 /*: any*/,
          concreteType: 'CemeteryResult',
          kind: 'LinkedField',
          name: 'listCemeteries',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'Faq_rankingCemeteries'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'Ranking_rankingCemeteries'
            },
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'PopularCemeteries_rankingCemeteries'
            }
          ],
          storageKey: null
        },
        {
          alias: 'highScoreCemeteries',
          args: v30 /*: any*/,
          concreteType: 'CemeteryResult',
          kind: 'LinkedField',
          name: 'listCemeteries',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'HighScoreCemeteries_highScoreCemeteries'
            }
          ],
          storageKey: null
        },
        {
          alias: 'stations',
          args: v32 /*: any*/,
          concreteType: 'StationWithCemeteryCountConnection',
          kind: 'LinkedField',
          name: 'listSameRailwayLineStationsWithCemeteryCountByStationId',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'StationLinksList_stations'
            }
          ],
          storageKey: null
        },
        {
          alias: 'conditions',
          args: v33 /*: any*/,
          concreteType: 'SearchChoiceWithCemeteryCountConnection',
          kind: 'LinkedField',
          name: 'listSearchChoicesWithCemeteryCount',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'ConditionLinksList_conditions'
            }
          ],
          storageKey: null
        },
        {
          alias: 'sectionTypes',
          args: v34 /*: any*/,
          concreteType: 'SearchChoiceWithCemeteryCountConnection',
          kind: 'LinkedField',
          name: 'listSearchChoicesWithCemeteryCount',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'SearchSectionTypeLinks_sectionTypes'
            }
          ],
          storageKey: null
        },
        {
          alias: 'shopCities',
          args: v35 /*: any*/,
          concreteType: 'CityWithShopCountConnection',
          kind: 'LinkedField',
          name: 'listCitiesWithShopCountByPrefectureRoma',
          plural: false,
          selections: [
            {
              args: null,
              kind: 'FragmentSpread',
              name: 'ShopLinksList_Fragment'
            }
          ],
          storageKey: null
        }
      ],
      type: 'Query',
      abstractKey: null
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [
        v4 /*: any*/,
        v12 /*: any*/,
        v9 /*: any*/,
        v0 /*: any*/,
        v10 /*: any*/,
        v8 /*: any*/,
        v1 /*: any*/,
        v2 /*: any*/,
        v5 /*: any*/,
        v6 /*: any*/,
        v7 /*: any*/,
        v3 /*: any*/,
        v11 /*: any*/
      ],
      kind: 'Operation',
      name: 'prefectureStationListPage_indexQuery',
      selections: [
        {
          alias: 'station',
          args: v13 /*: any*/,
          concreteType: 'StationWithCityCemeteryCount',
          kind: 'LinkedField',
          name: 'getStationWithCityCemeteryCount',
          plural: false,
          selections: [
            v14 /*: any*/,
            v36 /*: any*/,
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'cityId',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'cityName',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'cityCemeteryCount',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'railwayLineName',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'designatedCityId',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'designatedCityName',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'prefectureName',
              storageKey: null
            },
            v37 /*: any*/,
            v15 /*: any*/
          ],
          storageKey: null
        },
        {
          alias: 'cemeteries',
          args: v25 /*: any*/,
          concreteType: 'CemeteryResult',
          kind: 'LinkedField',
          name: 'listCemeteries',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'Cemetery',
              kind: 'LinkedField',
              name: 'items',
              plural: true,
              selections: [
                v38 /*: any*/,
                v36 /*: any*/,
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'kana',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'address',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryReviewSummary',
                  kind: 'LinkedField',
                  name: 'review_summary',
                  plural: false,
                  selections: [
                    v39 /*: any*/,
                    v40 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryReview',
                      kind: 'LinkedField',
                      name: 'valuable_review',
                      plural: false,
                      selections: [
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'age',
                          storageKey: null
                        },
                        {
                          alias: null,
                          args: null,
                          kind: 'ScalarField',
                          name: 'gender',
                          storageKey: null
                        },
                        {
                          alias: null,
                          args: null,
                          concreteType: 'CemeteryReviewAnswer',
                          kind: 'LinkedField',
                          name: 'answers',
                          plural: true,
                          selections: [
                            v41 /*: any*/,
                            {
                              alias: null,
                              args: null,
                              kind: 'ScalarField',
                              name: 'text',
                              storageKey: null
                            }
                          ],
                          storageKey: null
                        }
                      ],
                      storageKey: null
                    }
                  ],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryDescription',
                  kind: 'LinkedField',
                  name: 'descriptions',
                  plural: true,
                  selections: [
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'subject',
                      storageKey: null
                    }
                  ],
                  storageKey: null
                },
                v42 /*: any*/,
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryStation',
                  kind: 'LinkedField',
                  name: 'stations',
                  plural: true,
                  selections: [
                    v14 /*: any*/,
                    v43 /*: any*/,
                    v36 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      kind: 'ScalarField',
                      name: 'nearest',
                      storageKey: null
                    }
                  ],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryChoice',
                  kind: 'LinkedField',
                  name: 'section_types',
                  plural: true,
                  selections: [v41 /*: any*/, v36 /*: any*/],
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryChoice',
                  kind: 'LinkedField',
                  name: 'features',
                  plural: true,
                  selections: v44 /*: any*/,
                  storageKey: null
                },
                v46 /*: any*/,
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryChoice',
                  kind: 'LinkedField',
                  name: 'sects',
                  plural: true,
                  selections: v45 /*: any*/,
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryImage',
                  kind: 'LinkedField',
                  name: 'main_image',
                  plural: false,
                  selections: v49 /*: any*/,
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryImage',
                  kind: 'LinkedField',
                  name: 'sub_images',
                  plural: true,
                  selections: v49 /*: any*/,
                  storageKey: null
                },
                v52 /*: any*/,
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'requestable',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'updated_at',
                  storageKey: null
                },
                v41 /*: any*/
              ],
              storageKey: null
            },
            v53 /*: any*/,
            {
              alias: null,
              args: null,
              concreteType: 'PaginationStatus',
              kind: 'LinkedField',
              name: 'pagination',
              plural: false,
              selections: [
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'currentPageNumber',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'hasNext',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'hasPrev',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'lastPageNumber',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'perPageSize',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'from',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'to',
                  storageKey: null
                }
              ],
              storageKey: null
            }
          ],
          storageKey: null
        },
        {
          alias: 'averages',
          args: v28 /*: any*/,
          concreteType: 'CemeteryPriceAverages',
          kind: 'LinkedField',
          name: 'averageCemeteryPrices',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'PriceAverage',
              kind: 'LinkedField',
              name: 'averages',
              plural: true,
              selections: [
                v50 /*: any*/,
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'price',
                  storageKey: null
                }
              ],
              storageKey: null
            }
          ],
          storageKey: null
        },
        {
          alias: 'rankingCemeteries',
          args: v29 /*: any*/,
          concreteType: 'CemeteryResult',
          kind: 'LinkedField',
          name: 'listCemeteries',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'Cemetery',
              kind: 'LinkedField',
              name: 'items',
              plural: true,
              selections: [
                v38 /*: any*/,
                v36 /*: any*/,
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryNearestStation',
                  kind: 'LinkedField',
                  name: 'nearest_station',
                  plural: false,
                  selections: [v43 /*: any*/, v36 /*: any*/],
                  storageKey: null
                },
                {
                  kind: 'InlineFragment',
                  selections: [
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryPrefecture',
                      kind: 'LinkedField',
                      name: 'prefecture',
                      plural: false,
                      selections: v44 /*: any*/,
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryCity',
                      kind: 'LinkedField',
                      name: 'city',
                      plural: false,
                      selections: v44 /*: any*/,
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryReviewSummary',
                      kind: 'LinkedField',
                      name: 'review_summary',
                      plural: false,
                      selections: [v39 /*: any*/, v40 /*: any*/],
                      storageKey: null
                    },
                    v42 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryImage',
                      kind: 'LinkedField',
                      name: 'main_image',
                      plural: false,
                      selections: [v48 /*: any*/, v47 /*: any*/],
                      storageKey: null
                    },
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryChoice',
                      kind: 'LinkedField',
                      name: 'section_types',
                      plural: true,
                      selections: v44 /*: any*/,
                      storageKey: null
                    },
                    v46 /*: any*/,
                    {
                      alias: null,
                      args: null,
                      concreteType: 'CemeteryChoice',
                      kind: 'LinkedField',
                      name: 'sects',
                      plural: true,
                      selections: v44 /*: any*/,
                      storageKey: null
                    },
                    v52 /*: any*/
                  ],
                  type: 'CemeteryBase',
                  abstractKey: '__isCemeteryBase'
                }
              ],
              storageKey: null
            },
            v53 /*: any*/
          ],
          storageKey: null
        },
        {
          alias: 'highScoreCemeteries',
          args: v30 /*: any*/,
          concreteType: 'CemeteryResult',
          kind: 'LinkedField',
          name: 'listCemeteries',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'Cemetery',
              kind: 'LinkedField',
              name: 'items',
              plural: true,
              selections: [
                v38 /*: any*/,
                v36 /*: any*/,
                {
                  alias: null,
                  args: null,
                  concreteType: 'CemeteryReviewSummary',
                  kind: 'LinkedField',
                  name: 'review_summary',
                  plural: false,
                  selections: [v40 /*: any*/, v39 /*: any*/],
                  storageKey: null
                }
              ],
              storageKey: null
            }
          ],
          storageKey: null
        },
        {
          alias: 'stations',
          args: v32 /*: any*/,
          concreteType: 'StationWithCemeteryCountConnection',
          kind: 'LinkedField',
          name: 'listSameRailwayLineStationsWithCemeteryCountByStationId',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'StationWithCemeteryCount',
              kind: 'LinkedField',
              name: 'items',
              plural: true,
              selections: [
                v14 /*: any*/,
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'isMain',
                  storageKey: null
                },
                v36 /*: any*/,
                v54 /*: any*/
              ],
              storageKey: null
            }
          ],
          storageKey: null
        },
        {
          alias: 'conditions',
          args: v33 /*: any*/,
          concreteType: 'SearchChoiceWithCemeteryCountConnection',
          kind: 'LinkedField',
          name: 'listSearchChoicesWithCemeteryCount',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'SearchChoiceWithCemeteryCount',
              kind: 'LinkedField',
              name: 'items',
              plural: true,
              selections: [
                v41 /*: any*/,
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'attributeCode',
                  storageKey: null
                },
                v36 /*: any*/,
                v54 /*: any*/
              ],
              storageKey: null
            }
          ],
          storageKey: null
        },
        {
          alias: 'sectionTypes',
          args: v34 /*: any*/,
          concreteType: 'SearchChoiceWithCemeteryCountConnection',
          kind: 'LinkedField',
          name: 'listSearchChoicesWithCemeteryCount',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'SearchChoiceWithCemeteryCount',
              kind: 'LinkedField',
              name: 'items',
              plural: true,
              selections: [v54 /*: any*/, v41 /*: any*/, v36 /*: any*/],
              storageKey: null
            }
          ],
          storageKey: null
        },
        {
          alias: 'shopCities',
          args: v35 /*: any*/,
          concreteType: 'CityWithShopCountConnection',
          kind: 'LinkedField',
          name: 'listCitiesWithShopCountByPrefectureRoma',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              concreteType: 'CityWithShopCount',
              kind: 'LinkedField',
              name: 'items',
              plural: true,
              selections: [
                v37 /*: any*/,
                v36 /*: any*/,
                {
                  alias: 'cityId',
                  args: null,
                  kind: 'ScalarField',
                  name: 'id',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'shopCount',
                  storageKey: null
                }
              ],
              storageKey: null
            }
          ],
          storageKey: null
        }
      ]
    },
    params: {
      cacheID: '25f060e72055da2dffad0f7caf83055d',
      id: null,
      metadata: {},
      name: 'prefectureStationListPage_indexQuery',
      operationKind: 'query',
      text: 'query prefectureStationListPage_indexQuery(\n  $prefectureRoma: String!\n  $stationId: Int!\n  $sectionTypes: [String!]\n  $cemeteryTypes: [String!]\n  $sects: [String!]\n  $sectionCapacities: [String!]\n  $facilities: [String!]\n  $features: [String!]\n  $priceMax: String\n  $priceMin: String\n  $priceRange: PriceRangeInput\n  $from: Int = 0\n  $sort: CemeterySortInput\n) {\n  station: getStationWithCityCemeteryCount(id: $stationId) {\n    ...ListPageContextProvider_station\n    mainStation {\n      stationId: id\n    }\n  }\n  cemeteries: listCemeteries(filter: {prefectures: [$prefectureRoma], stations: [$stationId], cemeteryTypes: $cemeteryTypes, sectionTypes: $sectionTypes, sects: $sects, sectionCapacities: $sectionCapacities, facilities: $facilities, features: $features, priceMax: $priceMax, priceMin: $priceMin, priceRange: $priceRange}, page: {from: $from, size: 20}, sort: $sort) {\n    ...CemeteryList_cemeteries\n    ...StructuredData_cemeteries\n    ...ListPageContextProvider_pagination\n    ...NoCemeteries_cemeteries\n    ...ThirdPartyAdData_cemeteries\n    ...SeoHead_cemeteries\n  }\n  averages: averageCemeteryPrices(filter: {stations: [$stationId]}) {\n    ...useAveragePrices_averages\n  }\n  rankingCemeteries: listCemeteries(filter: {stations: [$stationId]}, page: {from: 0, size: 5}, sort: {field: "ranking", order: "desc"}) {\n    ...Faq_rankingCemeteries\n    ...Ranking_rankingCemeteries\n    ...PopularCemeteries_rankingCemeteries\n  }\n  highScoreCemeteries: listCemeteries(filter: {prefectures: [$prefectureRoma], stations: [$stationId], requestable: true}, page: {from: 0, size: 3}, sort: {field: "enquete_score", order: "desc"}) {\n    ...HighScoreCemeteries_highScoreCemeteries\n  }\n  stations: listSameRailwayLineStationsWithCemeteryCountByStationId(stationId: $stationId, limit: 999) {\n    ...StationLinksList_stations\n  }\n  conditions: listSearchChoicesWithCemeteryCount(cemeteryFilter: {stations: [$stationId]}, limit: 99) {\n    ...ConditionLinksList_conditions\n  }\n  sectionTypes: listSearchChoicesWithCemeteryCount(attributeCode: "section_type", cemeteryFilter: {prefectures: [$prefectureRoma], stations: [$stationId], cemeteryTypes: $cemeteryTypes, sects: $sects, sectionCapacities: $sectionCapacities, facilities: $facilities, features: $features, priceMax: $priceMax, priceMin: $priceMin}) {\n    ...SearchSectionTypeLinks_sectionTypes\n  }\n  shopCities: listCitiesWithShopCountByPrefectureRoma(prefectureRoma: $prefectureRoma, limit: 999) {\n    ...ShopLinksList_Fragment\n  }\n}\n\nfragment CemeteryList_cemeteries on CemeteryResult {\n  items {\n    cemeteryId: id\n    name\n    kana\n    address\n    review_summary {\n      total_score\n      count\n      valuable_review {\n        age\n        gender\n        answers {\n          code\n          text\n        }\n      }\n    }\n    descriptions {\n      subject\n    }\n    director_comment\n    stations {\n      stationId: id\n      distance\n      name\n      nearest\n    }\n    section_types {\n      code\n      name\n    }\n    features {\n      name\n    }\n    cemetery_types {\n      name\n      code\n    }\n    sects {\n      name\n      code\n    }\n    main_image {\n      path\n      alt\n    }\n    sub_images {\n      path\n      alt\n    }\n    best_price_by_category {\n      normal {\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n      nokotsu {\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n      jumoku {\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n      eitai_kuyo {\n        price1\n        price1_unit\n        price2\n        price2_unit\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n        lot_area\n      }\n    }\n    requestable\n  }\n}\n\nfragment ConditionLinksList_conditions on SearchChoiceWithCemeteryCountConnection {\n  items {\n    code\n    attributeCode\n    name\n    cemeteryCount\n  }\n}\n\nfragment Faq_rankingCemeteries on CemeteryResult {\n  items {\n    cemeteryId: id\n    name\n  }\n  total\n}\n\nfragment HighScoreCemeteries_highScoreCemeteries on CemeteryResult {\n  items {\n    cemeteryId: id\n    name\n    review_summary {\n      count\n      total_score\n    }\n  }\n}\n\nfragment ListPageContextProvider_pagination on CemeteryResult {\n  total\n  pagination {\n    currentPageNumber\n    hasNext\n    hasPrev\n    lastPageNumber\n    perPageSize\n    from\n    to\n  }\n}\n\nfragment ListPageContextProvider_station on StationWithCityCemeteryCount {\n  stationId: id\n  name\n  cityId\n  cityName\n  cityCemeteryCount\n  railwayLineName\n  designatedCityId\n  designatedCityName\n  prefectureName\n  prefectureRoma\n}\n\nfragment NoCemeteries_cemeteries on CemeteryResult {\n  total\n}\n\nfragment PopularCemeteries_rankingCemeteries on CemeteryResult {\n  items {\n    cemeteryId: id\n    name\n    nearest_station {\n      distance\n      name\n    }\n  }\n}\n\nfragment Ranking_rankingCemeteries on CemeteryResult {\n  items {\n    cemeteryId: id\n    ...useCemeteryTinyItem_cemetery\n  }\n}\n\nfragment SearchSectionTypeLinks_sectionTypes on SearchChoiceWithCemeteryCountConnection {\n  items {\n    cemeteryCount\n    code\n    name\n  }\n}\n\nfragment SeoHead_cemeteries on CemeteryResult {\n  items {\n    main_image {\n      path\n    }\n  }\n}\n\nfragment ShopLinksList_Fragment on CityWithShopCountConnection {\n  items {\n    prefectureRoma\n    name\n    cityId: id\n    shopCount\n  }\n}\n\nfragment StationLinksList_stations on StationWithCemeteryCountConnection {\n  items {\n    stationId: id\n    isMain\n    name\n    cemeteryCount\n  }\n}\n\nfragment StructuredData_cemeteries on CemeteryResult {\n  items {\n    updated_at\n  }\n}\n\nfragment ThirdPartyAdData_cemeteries on CemeteryResult {\n  items {\n    cemeteryId: id\n    code\n    best_price_by_category {\n      normal {\n        price1\n        price1_unit\n        price2\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n      }\n      nokotsu {\n        price1\n        price1_unit\n        price2\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n      }\n      jumoku {\n        price1\n        price1_unit\n        price2\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n      }\n      eitai_kuyo {\n        price1\n        price1_unit\n        price2\n        purchase_price\n        purchase_price_unit\n        calculated_purchase_price\n        category_code\n        purchase_price_option\n        price3\n        simulated_price3\n        price4\n        price4_name\n      }\n    }\n  }\n}\n\nfragment useAveragePrices_averages on CemeteryPriceAverages {\n  averages {\n    category_code\n    price\n  }\n}\n\nfragment useCemeteryTinyItem_cemetery on CemeteryBase {\n  __isCemeteryBase: __typename\n  cemeteryId: id\n  name\n  prefecture {\n    name\n  }\n  city {\n    name\n  }\n  review_summary {\n    total_score\n    count\n  }\n  director_comment\n  main_image {\n    alt\n    path\n  }\n  section_types {\n    name\n  }\n  cemetery_types {\n    name\n    code\n  }\n  sects {\n    name\n  }\n  best_price_by_category {\n    normal {\n      price1\n      price1_unit\n      price2\n      price2_unit\n      purchase_price\n      purchase_price_unit\n      calculated_purchase_price\n      category_code\n      purchase_price_option\n      price3\n      simulated_price3\n      price4\n      price4_name\n      lot_area\n    }\n    nokotsu {\n      price1\n      price1_unit\n      price2\n      price2_unit\n      purchase_price\n      purchase_price_unit\n      calculated_purchase_price\n      category_code\n      purchase_price_option\n      price3\n      simulated_price3\n      price4\n      price4_name\n      lot_area\n    }\n    jumoku {\n      price1\n      price1_unit\n      price2\n      price2_unit\n      purchase_price\n      purchase_price_unit\n      calculated_purchase_price\n      category_code\n      purchase_price_option\n      price3\n      simulated_price3\n      price4\n      price4_name\n      lot_area\n    }\n    eitai_kuyo {\n      price1\n      price1_unit\n      price2\n      price2_unit\n      purchase_price\n      purchase_price_unit\n      calculated_purchase_price\n      category_code\n      purchase_price_option\n      price3\n      simulated_price3\n      price4\n      price4_name\n      lot_area\n    }\n  }\n}\n'
    }
  }
})()

;(node as any).hash = 'd80039e76a2d0bb80df26a7789288239'

export default node
